import { render } from "./Tokens.vue?vue&type=template&id=6c9544c6"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"

import "./Tokens.vue?vue&type=style&index=0&id=6c9544c6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__